import React from 'react';
import type { StylePack } from '@/themes/stylePack.types';

/**
 * Прибитая шапка квиза (пак `chrome.sticky`, spec shared/header.md «Что
 * добавить» п.3): `position: sticky; top: 0`, фон страницы, поля 16/0,
 * ширина — окно телефона целиком (шире колонки на поля экрана), от 920 px —
 * не шире `chrome.maxWidth` (эталон 613) по центру и с верхним отступом
 * `chrome.desktopTopPad` (эталон 84). Разметка — класс `.qb-chrome-sticky` в
 * styles/public-paywall.css.
 *
 * Без `chrome.sticky` — возвращает шапку как есть: разметка старых воронок
 * не меняется ни на один узел.
 */
export const CHROME_DEFAULT_DESKTOP_TOP_PAD = 16;

export function QuizChromeFrame({
  pack,
  preview,
  children,
}: {
  pack: StylePack | undefined;
  preview: boolean;
  children: React.ReactNode;
}) {
  if (!pack?.chrome.sticky || children === null || children === undefined) {
    return <>{children}</>;
  }
  const { maxWidth, desktopTopPad } = pack.chrome;
  return (
    <div
      className="qb-chrome-sticky"
      data-testid="quiz-chrome-sticky"
      data-preview={preview ? 'true' : undefined}
      style={
        {
          '--chrome-max-w':
            typeof maxWidth === 'number' ? `${maxWidth}px` : '100%',
          '--chrome-desktop-top-pad': `${
            typeof desktopTopPad === 'number'
              ? desktopTopPad
              : CHROME_DEFAULT_DESKTOP_TOP_PAD
          }px`,
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
}
